import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';
import { Box, Divider, Grid, Typography, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import PickUpClinic from './pick-up-clinic.component';
import DeliveryClinic from './delivery-clinic.component';
import PickUpClinicPostalAddress from './pick-up-clinic-postal-address.component';
import DeliveryClinicPostalAddress from './delivery-clinic-postal-address.component';

type DeliverySectionProps = {
    order: Order;
    versionCheck: boolean;
    redirectToModifyOrder: (isResend: boolean) => void;
    isCustomer: boolean;
    isExternalTechnician: boolean;
};
const DeliverySection: FC<DeliverySectionProps> = ({
    order,
    versionCheck,
    redirectToModifyOrder,
    isCustomer,
    isExternalTechnician,
}: DeliverySectionProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [tabState, setTabState] = useState<string>('delivery-address');

    const handleTabChange = (_event: unknown, newTabState: string) => {
        setTabState(newTabState);
    };

    return (
        <Fragment>
            <TabContext value={tabState}>
                <Box mb={2}>
                    <TabList indicatorColor="primary" textColor="primary" onChange={handleTabChange}>
                        <Tab
                            icon={<ContactMailIcon color="primary" />}
                            label={translate('orders:DELIVERY_ADDRESS')}
                            value="delivery-address"
                            data-testid="delivery-section.delivery-address-tab"
                        />
                        <Tab
                            icon={<LocalPostOfficeIcon color="primary" />}
                            label={translate('orders:POSTAL_ADDRESS')}
                            value="postal-address"
                            data-testid="delivery-section.postal-address-tab"
                        />
                    </TabList>
                </Box>
                <TabPanel sx={{ padding: 0 }} value="delivery-address">
                    <PickUpClinic
                        order={order}
                        versionCheck={versionCheck}
                        redirectToModifyOrder={redirectToModifyOrder}
                        isCustomer={isCustomer}
                        isExternalTechnician={isExternalTechnician}
                    />
                    <Divider sx={{ marginBottom: 2, borderColor: '#eee' }} />
                    <DeliveryClinic
                        order={order}
                        versionCheck={versionCheck}
                        redirectToModifyOrder={redirectToModifyOrder}
                        isCustomer={isCustomer}
                        isExternalTechnician={isExternalTechnician}
                    />
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="postal-address">
                    <PickUpClinicPostalAddress order={order} />
                    <Divider sx={{ marginBottom: 2, borderColor: '#eee' }} />
                    <DeliveryClinicPostalAddress order={order} />
                </TabPanel>
            </TabContext>

            {order.approvedBy ? (
                <Fragment>
                    <Divider sx={{ marginBottom: 2, borderColor: '#eee' }} />
                    <Box>
                        <Box mb={1} display="flex" alignItems="flex-end">
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <Typography variant="subtitle2">{translate('orders:APPROVED_BY')}:</Typography>
                                    {order.approvedBy?.fullName}
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Fragment>
            ) : undefined}
        </Fragment>
    );
};

export default DeliverySection;
